import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17295242"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1))
const _hoisted_3 = { class: "sm:col-span-4 main-content" }
const _hoisted_4 = {
  key: 0,
  class: "question-label question-label-project2"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "mt-8 mb-4 justify-items-stretch flex flex-col text-lg" }
const _hoisted_8 = ["name", "value", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_ctx.config.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("span", null, null, 512), [
                    [_directive_t, _ctx.config.title]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.config.textPart1)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "mt-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              class: "mt-4",
              innerHTML: _ctx.$t(_ctx.config.question, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.options, (option, key) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: key,
                  class: "flex flex-row items-center mb-4"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: _ctx.config.answerKey,
                    value: key,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.answers.value[_ctx.config.answerKey]) = $event)),
                    onChange: ($event: any) => (_ctx.answer(key, {[key]: _ctx.$t(option)})),
                    class: "inline mr-4 large-radio-circle"
                  }, null, 40, _hoisted_8), [
                    [_vModelRadio, _ctx.state.answers.value[_ctx.config.answerKey]]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(option)), 1)
                ]))
              }), 128))
            ]),
            _createVNode(_component_BackNextButtons, {
              "go-to": _ctx.goTo,
              "next-screen": _ctx.config.screenNext,
              "button-class": "action-button action-button-project2 mt-auto"
            }, null, 8, ["go-to", "next-screen"])
          ]),
          (_ctx.config.bgImage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-span-4 h-full min-h-50vh flex-col items-center flex",
                style: _normalizeStyle(`background-image: ${_ctx.config.bgImage}; background-size: cover;  background-repeat: no-repeat; background-position: center; ${_ctx.config.bgStyles}`)
              }, null, 4))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}